import React, { useState } from "react"
import Input from "../../atoms/input/input"
import Button from "../../atoms/button/button"
import "./select-method-otp.scss"

const DEFAULT_TITLE = "Necesitamos verificar"
const DEFAULT_SUBTITLE = "QUE ERES TÚ"
const DEFAULT_DESCRIPTION =
  "Necesitamos verificar que eres tú, te enviaremos un código único para que lo ingreses a continuación. Elige el medio por el cuál quieres realizar esta validación."

const SelectMethodOtp = ({
  title = DEFAULT_TITLE,
  subtitle = DEFAULT_SUBTITLE,
  description = DEFAULT_DESCRIPTION,
  onSubmit,
}) => {
  const [selectedValue, setSelectedValue] = useState("SMS")

  return (
    <div className="f-select-method-otp">
      <h3 className="f-title-modal">{title}</h3>
      <h4 className="f-subtitle-modal">{subtitle}</h4>
      <p className="f-description-modal">{description}</p>
      <div className="f-method-form">
        <div className="f-radio">
          <Input
            type="radio"
            name="method"
            value="SMS"
            checked={selectedValue === "SMS"}
            onChange={e => {
              setSelectedValue(e.target.value)
            }}
          />
          <label className="f-radio__label">Celular (SMS)</label>
        </div>

        <div className="f-radio">
          <Input
            type="radio"
            name="method"
            value="EMAIL"
            checked={selectedValue === "EMAIL"}
            chec
            onChange={e => {
              setSelectedValue(e.target.value)
            }}
          />
          <label className="f-radio__label">Correo</label>
        </div>
      </div>
      <Button
        title="Siguiente"
        className="primary-pink short"
        onClick={() => {
          onSubmit(selectedValue)
        }}
      />
    </div>
  )
}

export default SelectMethodOtp
